module.exports = __webpack_public_path__ + "static/media/13.5cc9796a.jpg";